module.exports = __webpack_public_path__ + "208c1efe663d2a7c90338b7c1018e4cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_1.jpg
// module id = 1725
// module chunks = 5